<h1 class="mb-4">
  <mdb-icon fas icon="cog"></mdb-icon> Libro de Ventas
</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Compras y Ventas</span>
      <span> /</span>
      <span>Libro de Ventas</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">

      <div class="row filtros-body">
        <div class="col" style="max-width: 300px;">
          <!-- Material checked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_RESUMEN" />
            <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
          </div>
          <!-- Material unchecked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_DETALLE" />
            <label class="form-check-label" for="rbVistaDetalle">Vista Detallada</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsYear" [filterEnabled]="true" [highlightFirst]="false" placeholder="Año"
              formControlName="anho"></mdb-select>
            <label>Año</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsMonth" [filterEnabled]="true" [highlightFirst]="false" placeholder="Mes"
              formControlName="mes"></mdb-select>
            <label>Mes</label>
          </div>
        </div>
        <div class="col">
          <div class="md-form" style="max-width: 300px">
            <mdb-select [options]="optionsTipoDTE" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="listaTipoDTE"></mdb-select>
            <label>Tipo de Documento</label>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-between">

    <!-- *ngIf="listaMovimientos" -->
    <!-- <div class="table-responsive"> -->
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <!-- <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
        </app-no-data-alert> -->

      <!-- *ngIf="listaMovimientos?.length > 0" -->
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="resumen_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Nombre Tip. Doc.</th>
            <th scope="col">Cantidad</th>
            <th scope="col">Afecto</th>
            <th scope="col">Exento</th>
            <th scope="col">Otro Imp.</th>
            <th scope="col">IVA</th>
            <th scope="col">IVA No Recup.</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="resumen_loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center"
              *ngIf="!resumen_loading && resumen_listaMovimientos?.length === 0">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of resumen_listaMovimientos">
            <td>{{ mov.tipo_dte_nombre }}</td>
            <td>{{ mov.cantidad_documento }}</td>
            <td>{{ mov.monto_afecto | numerico }}</td>
            <td>{{ mov.monto_exento | numerico }}</td>
            <td>{{ mov.impto_adic | numerico }}</td>
            <td>{{ mov.monto_iva | numerico }}</td>
            <td>{{ mov.monto_iva_no_recup | numerico }}</td>
            <td>{{ mov.monto_total | numerico }}</td>
          </tr>
        </tbody>
        <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)"
          *ngIf="resumen_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
    <!-- INICIO DEL DETALLE-->
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Nombre Tip. Doc.</th>
            <th scope="col">Folio</th>
            <th scope="col">Fecha</th>
            <th scope="col">Rut</th>
            <th scope="col">Razon Social</th>
            <th scope="col">Afecto</th>
            <th scope="col">Exento</th>
            <th scope="col">Otro Imp.</th>
            <th scope="col">IVA</th>
            <th scope="col">IVA No Recup.</th>
            <th scope="col">Total</th>
            <th scope="col">Casa Matriz</th>
            <!-- <th scope="col"></th>
              <th scope="col"></th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="detalle_loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center"
              *ngIf="!detalle_loading && detalle_listaMovimientos?.length === 0">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of detalle_listaMovimientos">
            <td>{{ mov.tipo_dte_nombre }}</td>
            <td>{{ mov.folio }}</td>
            <td>{{ mov.fecha_registro | fecha }}</td>
            <td>{{ mov.rutFormato | rut}}</td>
            <td>{{ mov.cliente_nombre }}</td>
            <td>{{ mov.monto_afecto | numerico }}</td>
            <td>{{ mov.monto_exento | numerico }}</td>
            <td>{{ mov.impto_adic | numerico }}</td>
            <td>{{ mov.monto_iva | numerico}}</td>
            <td>{{ mov.monto_iva_no_recup | numerico}}</td>
            <td>{{ mov.monto_total | numerico}}</td>
            <td class="text-center">{{ mov.es_casa_matriz }}</td>
          </tr>
        </tbody>
        <app-pagination [context]="detalle_paginationContext" (onPageChange)="detalleOnPageChange($event)"
          *ngIf="detalle_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientosAll?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="grey lighten-2">
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Cantidad</th>
          <th scope="col">Afecto</th>
          <th scope="col">Exento</th>
          <th scope="col">Otro Imp.</th>
          <th scope="col">IVA</th>
          <th scope="col">IVA No Recup.</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Totales</strong></td>
          <td></td>
          <td></td>
          <td> {{resumen_totales.cantidad_documento | numerico}}</td>
          <td>{{ resumen_totales.monto_afecto | numerico}}</td>
          <td>{{ resumen_totales.monto_exento | numerico}}</td>
          <td>{{ resumen_totales.impto_adic | numerico}}</td>
          <td>{{ resumen_totales.monto_iva | numerico}}</td>
          <td>{{ resumen_totales.monto_iva_no_recup | numerico}}</td>
          <td>{{ resumen_totales.monto_total | numerico}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientosAll?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="grey lighten-2">
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Cantidad</th>
          <th scope="col">Afecto</th>
          <th scope="col">Exento</th>
          <th scope="col">Otro Imp.</th>
          <th scope="col">IVA</th>
          <th scope="col">IVA No Recup.</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Totales</strong></td>
          <td></td>
          <td></td>
          <td> {{detalle_totales.cantidad_documento | numerico}}</td>
          <td>{{ detalle_totales.monto_afecto | numerico}}</td>
          <td>{{ detalle_totales.monto_exento | numerico}}</td>
          <td>{{ detalle_totales.impto_adic | numerico}}</td>
          <td>{{ detalle_totales.monto_iva | numerico}}</td>
          <td>{{ detalle_totales.monto_iva_no_recup | numerico}}</td>
          <td>{{ detalle_totales.monto_total | numerico}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="resumenDownloadExcelPdf('XLS')">
      Excel
    </button>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="detalleDownloadExcelPdf('XLS')">
      Excel
    </button>
  </div>
</div>
